const common = {
  search: 'Buscar...',
  select: 'Seleccionar',
  selectDropdown: 'Seleccionar...',
  loading: 'Cargando...',
  selected: '{{count}} seleccionados ',
  noOptions: 'Sin opciones',
  all: 'Todos',
  allWithName: 'Todos {{name}}',
  add: 'Añadir',
  selectAll: 'Seleccionar todo',
  unselectAll: 'Deseleccionar todo',
  enter: 'Ingrese',
  items: '{{count}} elementos, ',
  shortWeekdays: ['L', 'M', 'X', 'J', 'V', 'S', 'D'],
  distanceType: {
    metric: 'Km',
    imperial: 'Mi',
  },
  hour: 'Hora',
  reductions: {
    h: 'h',
    m: 'm',
    s: 's',
  },
  connectorStatus: {
    free: 'Disponible',
    busy: 'No disponible',
    unknown: 'Desconocido',
    error: 'Averiado',
  },
  yes: 'Sí',
  no: 'No',
  weekDays: {
    sunday: 'domingo',
    monday: 'lunes',
    tuesday: 'martes',
    wednesday: 'miércoles',
    thursday: 'jueves',
    friday: 'viernes',
    saturday: 'sábado',
  },
  internal: 'Interno',
  google: 'Google',
  operationAddress: {
    student: 'Dirección del estudiante',
    employee: 'Dirección del empleado',
  },
  map: {
    zoomIn: 'Acercar',
    zoomOut: 'Alejar',
    fullScreen: 'Pantalla completa',
    polygon: {
      exceededModal: {
        body: 'La circunferencia de una zona "Bloque" no puede exceder los 10 km',
        cancel: 'Cancelar',
      },
      deleteModal: {
        header: '¿Eliminar polígono?',
        body: 'Estás a punto de eliminar el polígono',
      },
    },
  },
  roles: {
    dispatchadmin: 'Administrador de despacho',
    dispatcher: 'Despachador',
    superagent: 'Super Agente',
    agent: 'Agente',
    supplier: 'Proveedor',
    superadmin: 'Super Administrador',
    accountingadmin: 'Administrador de contabilidad',
    accountant: 'Contador',
    companyadmin: 'Administrador de la empresa',
    admin: 'Administrador',
  },
  duration: 'Duración',
  distance: 'Distancia',
};

export default common;
